module.exports = __webpack_public_path__ + "static/media/info.5efb76e8.svg";